import { isAnyFilterActive } from "@modules/azm/filter"
import { isMobile } from "@modules/util/device"
import { initSwiperContainer } from "@modules/util/swiper"
import type { SwiperContainer } from "swiper/element"
import { Autoplay, Pagination } from "swiper/modules"
import "swiper/css/pagination"
// @ts-expect-error typescript cannot find a type for this file.
import swiperCssAutoplay from "swiper/element/css/autoplay?raw"
// @ts-expect-error typescript cannot find a type for this file.
import swiperCssPagination from "swiper/element/css/pagination?raw"

function bigTeaserChangeVisibility(shouldBeVisible: boolean) {
    if (!isMobile()) {
        return // TODO homepage PC
    }

    const bigTeaserHeader = document.querySelector(".big-teaser-header")
    const bigTeaserSwiper = document.getElementById("swiper-big-teaser")
    if (bigTeaserSwiper?.classList.contains("hidden-no-teasers")) {
        return
    }

    if (!shouldBeVisible) {
        bigTeaserHeader?.classList.add("hidden-no-adverts")
        bigTeaserSwiper?.classList.add("hidden-no-adverts")
    } else {
        bigTeaserSwiper?.classList.remove("hidden-no-adverts")
        bigTeaserHeader?.classList.remove("hidden-no-adverts")
    }
}

window.addEventListener("azm.filter-api.after-fetch", () => {
    bigTeaserChangeVisibility(!isAnyFilterActive())
})

bigTeaserChangeVisibility(!isAnyFilterActive())

const swiperContainer = document.getElementById("swiper-big-teaser")
if (swiperContainer) {
    initSwiperContainer(swiperContainer as SwiperContainer, {
        modules: [Pagination, Autoplay],
        injectStyles: [swiperCssAutoplay, swiperCssPagination],
    })
}
